
const digest = 'a2e1d20880af765a9bbedea2dc0a2fef133f547d61e5bffbc1d9d57afaf17368';
const classes = {"wrapper":"_wrapper_qdehr_1"};
const css = `._wrapper_qdehr_1 {
  width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  